const RETENTION_ROUTES = {
    HOME: "/retention/V3",
    REPORTS: "/retention/V2/reports",
    EMPLOYEES: "/retention/V3/employees",
    TASK_CENTER: "/retention/V3/inbox",
    SETTINGS: "/retention/V3/settings",
    EXIT_SURVEY: "/retention/V3/exit-survey",
    EMPLOYEE_PROFILE: "/retention/V3/employees/:id",
    ESCALATION_WITH_AI: "/retention/V3/employees/:id/survey/:surveyId/escalation/:escalationId",
    SURVEY_DETAILS: "/retention/V3/employees/:id/survey-details",
    FOLLOW_UP_ACTIONS: "/retention/V3/employees/:id/follow-up-actions",
    FEED_TIMELINE: "/retention/V3/employees/:id/feed-timeline",
    EXIT_SURVEY_DETAIL: "/retention/V3/exit-survey/:id",
}

/**
 * Get the employee profile route based on agency_id
 * @param {number} agencyId - The agency ID
 * @returns {string} The appropriate employee profile route
 */
export const getEmployeeProfileRoute = (agencyId: number): string => {
    // Graham Healthcare Group (agency_id 36) uses v2 route
    if (agencyId === 36) {
        return "/retention/V2/employees/:id";
    }
    return RETENTION_ROUTES.EMPLOYEE_PROFILE;
};

/**
 * Get the home route based on agency_id
 * @param {number} agencyId - The agency ID
 * @returns {string} The appropriate home route
 */
export const getHomeRoute = (agencyId: number): string => {
    // Graham Healthcare Group (agency_id 36) uses v2 inbox
    if (agencyId === 36) {
        return "/retention/V2/inbox";
    }
    return RETENTION_ROUTES.HOME;
};

/**
 * Check if user should be redirected based on current path and agency_id
 * @param {string} currentPath - Current path
 * @param {number} agencyId - The agency ID
 * @returns {string | null} Redirect path or null if no redirect needed
 */
export const getRedirectPath = (currentPath: string, agencyId: number): string | null => {
    // Only redirect for Graham Healthcare Group (agency_id 36)
    if (agencyId !== 36) {
        return null;
    }

    // Redirect v3 routes to v2 for agency 36
    if (currentPath === '/retention/V3') {
        return '/retention/V2/inbox';
    }
    
    if (currentPath === '/retention/V3/inbox') {
        return '/retention/V2/inbox';
    }
    
    if (currentPath.startsWith('/retention/V3/employees/') && currentPath.match(/^\/retention\/V3\/employees\/\d+$/)) {
        return currentPath.replace('/retention/V3/', '/retention/V2/');
    }
    
    // Redirect escalation route to regular employee profile for agency 36
    const escalationMatch = currentPath.match(/^\/retention\/V3\/employees\/(\d+)\/survey\/\d+\/escalation\/\d+$/);
    if (escalationMatch) {
        console.log("escalationMatch", escalationMatch);
        const employeeId = escalationMatch[1];
        return `/retention/V2/employees/${employeeId}`;
    }
    
    // Redirect V2 index to inbox for agency 36
    if (currentPath === '/retention/V2') {
        return '/retention/V2/inbox';
    }
    
    return null;
};

export default RETENTION_ROUTES;